var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-popover', {
    attrs: {
      "offset": "0",
      "open": _vm.isOpen,
      "trigger": "manual",
      "autoHide": true
    },
    on: {
      "auto-hide": _vm.close
    }
  }, [_c('button', {
    staticClass: "tooltip-target btn btn-sm btn-link",
    attrs: {
      "data-testid": 'tasks-state-button-' + _vm.taskId
    },
    on: {
      "click": _vm.open
    }
  }, [(_vm.actualState === 'scheduled') ? _c('i', {
    staticClass: "fa fa-2x fa-circle-o text-info",
    attrs: {
      "aria-hidden": "true"
    }
  }) : (_vm.actualState === 'completed') ? _c('i', {
    staticClass: "fa fa-2x fa-check-circle text-success",
    attrs: {
      "aria-hidden": "true"
    }
  }) : (_vm.actualState === 'canceled') ? _c('i', {
    staticClass: "fa fa-2x fa-times-circle text-danger",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h4', [_vm._v(_vm._s(_vm.states[_vm.actualState]))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.actualState === 'scheduled') ? [_c('button', {
    staticClass: "btn btn-danger m-1",
    attrs: {
      "data-testid": 'tasks-state-cancel-' + _vm.taskId
    },
    on: {
      "click": function($event) {
        _vm.changeState('canceled')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-times-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.states.canceled))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success m-1",
    attrs: {
      "data-testid": 'tasks-state-complete-' + _vm.taskId
    },
    on: {
      "click": function($event) {
        _vm.changeState('completed')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-check-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.states.completed))])] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-outline-danger mt-3",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("zavřít")])])])])])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d3fa040","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Task/components/TaskChangeState.vue
// module id = 755
// module chunks = 0